// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"Qs3Dk"};